import { inject, Injectable } from '@angular/core';
import { Environment, ENVIRONMENT } from '@web/config';
import { HttpClient } from '@angular/common/http';
import { HttpContextBuilder } from '../builders/http-context.builder';
import { HttpHelperService } from '../services/http-helper.service';
import { HttpUrlFactory } from '../factories/http-url-factory.service';

@Injectable({
  providedIn: 'root',
})
export class ApiDependencyProviderService {
  public readonly environment = inject<Environment>(ENVIRONMENT);
  public readonly http = inject(HttpClient);
  public readonly httpHelper = inject(HttpHelperService);
  public readonly httpUrlFactory = inject(HttpUrlFactory);
  public readonly httpContextBuilder = inject(HttpContextBuilder);
}
